import { render, staticRenderFns } from "./acquire.vue?vue&type=template&id=3b5e593e&scoped=true&"
import script from "./acquire.vue?vue&type=script&lang=js&"
export * from "./acquire.vue?vue&type=script&lang=js&"
import style0 from "./acquire.vue?vue&type=style&index=0&id=3b5e593e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5e593e",
  null
  
)

export default component.exports